export default __webpack_public_path__ + "static/media/br.c2d9921e.svg";